module.exports = __webpack_public_path__ + "static/the-road-to-character-1609326c0150b45552f05352648a711d.jpg";